import { useGetMessageQuery } from '@pm/graphql';
import { Navigate, useParams } from 'react-router';
import { LoadingPage } from './LoadingPage';

export const ConversationRedirectPage = () => {
  const { messageId } = useParams();
  const { data: message } = useGetMessageQuery({
    variables: {
      id: messageId ?? '',
    },
  });

  if (message?.message) {
    return <Navigate to={`/conversations/${message.message.conversationId}`} />;
  }

  return <LoadingPage />;
};
